import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { configs } from "../../environments/deployments";
import { LogLevels } from "../types/Log/LogLevels";

@Injectable({ providedIn: "root" })
export class EnvironmentService {
  env: any = environment;

  public getEnvironment(): any {
    return this.env;
  }

  public getShowDevEnvironmentFlag(): any {
    return this.env.showDevEnvironment;
  }

  public getDevVariables(): any {
    return this.env.envVar;
  }

  public getVersion(): string {
    return this.env.version;
  }

  public getBuild(): string {
    return this.env.build;
  }

  public getAdminPortalUrl(key: string): string {
    return this.resolveCloudUrl(
      this.env.config.urls.cloud.ajax[key],
      configs.default.urls.cloud.ajax[key],
    );
  }

  public getServicesApiUrl(key: string): string {
    return this.resolveCloudUrl(
      this.env.config.urls.cloud.api[key],
      configs.default.urls.cloud.api[key],
    );
  }

  public getServicesApiPrivateKey(): string {
    return this.env.config.apiPrivateKey;
  }

  public getGoogleMapsApiKey(): string {
    return this.env.config.googleMapsAPIKey;
  }

  public getPrintablesUrl(): string {
    return this.resolveCloudUrl(
      this.env.config.urls.printables,
      configs.default.urls.printables,
    );
  }

  public getLogLevel(): LogLevels {
    const logLevel = this.env?.envVar?.logLevel;
    return logLevel ? logLevel.toUpperCase() : "ERROR";
  }

  public getLogTransports(): string {
    return this.env?.envVar?.logTransports;
  }

  private resolveCloudUrl(url: string, fallback: string): string {
    if (!url || !this.isProxyRelativeUrl(url)) {
      return url;
    }
    if (this.isLocalProxyHost()) {
      return url;
    }
    return fallback;
  }

  private isProxyRelativeUrl(url: string): boolean {
    return url.startsWith("/");
  }

  private getRuntimeLocation() {
    return globalThis.location;
  }

  private isLocalProxyHost(): boolean {
    const location = this.getRuntimeLocation();
    const host = location?.hostname || "";
    const protocol = location?.protocol || "";
    const isLocalHost = host === "localhost" || host === "127.0.0.1";
    const isWebProtocol = protocol === "http:" || protocol === "https:";
    return isLocalHost && isWebProtocol;
  }
}
